module.exports = __webpack_public_path__ + "static/media/settings.5ac03029.svg";